import React from "react";

import FilterHeader from "utils/columns/FilterHeader";
import DateCell from "../cells/DateColumn";
import EmailCell from "../cells/EmailColumn";
import LibraryActionCell from "../cells/LibraryActions";
import LibraryNameCell from "../cells/LibraryName";

import { Libraries } from "reducers/Libraries";
import QALocationCell from "../cells/QALocation";

export const LIBRARY_COLUMNS = [
	LibraryNameCell
	, {
		key: "id",
		name: "ID",
		className:"id-cell",
		cellClass:"cypress-creative-library-id",
		width:80,
		resizable:false,
		sortable:true,
	},
	LibraryActionCell,
	{
		key: "advertiserName",
		name: "Advertiser",
		cellClass:"cypress-creative-library-advertiser",
		resizable:true,
		sortable:true,
		headerRenderer: (
			<FilterHeader
				Reducer = {Libraries}
				filterSelector = {state => state.libraries.columnFilters.active.advertiserName}
			/>
		),
	},
	{
		key: "brand",
		name: "Brand",
		cellClass:"cypress-creative-library-brand",
		resizable:true,
		sortable:true,
		headerRenderer: (
			<FilterHeader
				Reducer = {Libraries}
				filterSelector = {state => state.libraries.columnFilters.active.brand}
			/>
		),
	},
	{
		...QALocationCell,
		cellClass: "cypress-creative-territory",
		filter:"Checkbox",
		headerRenderer: (
			<FilterHeader
				Reducer = {Libraries}
				filterSelector = {state => state.libraries.columnFilters.active.qaLocation}
			/>
		),
	},
	{
		...EmailCell,
		cellClass:"cypress-creative-library-primary-contact",
		headerRenderer: (
			<FilterHeader
				Reducer = {Libraries}
				filterSelector = {state => state.libraries.columnFilters.active.email}
			/>
		),
	},
	{
		key: "mediaBuyerName",
		name: "Media Buyer",
		cellClass:"cypress-creative-library-media-buyer",
		resizable:true,
		sortable:true,
		headerRenderer: (
			<FilterHeader
				Reducer = {Libraries}
				filterSelector = {state => state.libraries.columnFilters.active.mediaBuyerName}
			/>
		),
	},
	{
		...EmailCell,
		cellClass:"cypress-creative-library-media-buyer-email",
		key: "mediaBuyerEmail",
		name: "Media Buyer E-mail",
		headerRenderer: (
			<FilterHeader
				Reducer = {Libraries}
				filterSelector = {state => state.libraries.columnFilters.active.mediaBuyerEmail}
			/>
		),
	},
	{
		...DateCell,
		cellClass:"cypress-creative-library-date",
		headerRenderer: (
			<FilterHeader
				Reducer = {Libraries}
				filterSelector = {state => state.libraries.columnFilters.active.dateCreated}
			/>
		),
	}
];
